import {POST} from "@/services/gateway";

const listBackups = ({pagination, userIds, filter}) => {
  return POST('backup/list', {pagination, userIds, filter})
}

export {
  listBackups
}
